import { ContextMenu, HeaderModule, IconSelect, Button, IconUser } from 'uikit';

import { useKeycloak } from '@react-keycloak/web';
import type React from 'react';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { isAuthenticatedSelector } from '../../../app/selectors';

import Styles from './User.module.css';

type MenuItem = {
    label: string | number;
    onClick: (params: { e: React.MouseEvent<HTMLDivElement>; item: any }) => void;
};

const menuGetters = {
    getLabel: (item: MenuItem) => item.label,
    getItemOnClick: (item: MenuItem) => item.onClick,
};

export function User() {
    const { keycloak } = useKeycloak();
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const ref = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();

    const items: MenuItem[] = useMemo(
        () => [
            {
                label: 'Информация о системе',
                onClick: () => {
                    navigate('/systemInformation');
                    setIsMenuOpen(false);
                },
            },
            {
                label: 'Профиль',
                onClick: () => {
                    navigate('/profile');
                    setIsMenuOpen(false);
                },
            },
            {
                label: 'Выход',
                onClick: () => {
                    keycloak.logout();
                },
            },
        ],
        [keycloak, navigate],
    );

    const onClickHandler = useCallback(() => {
        if (isAuthenticated) {
            setIsMenuOpen(true);
        } else {
            keycloak.login();
        }
    }, [isAuthenticated, keycloak]);

    const clickOutsideHandler = useCallback(() => {
        setIsMenuOpen(false);
    }, []);

    return (
        <HeaderModule>
            <Button
                className={Styles.headerLogin}
                view="clear"
                iconRight={IconSelect}
                iconLeft={IconUser}
                onClick={onClickHandler}
                size="s"
                ref={ref}
                label=" "
            />
            <ContextMenu
                isOpen={isAuthenticated && isMenuOpen}
                items={items}
                getItemLabel={menuGetters.getLabel}
                getItemOnClick={menuGetters.getItemOnClick}
                anchorRef={ref}
                direction="downStartLeft"
                onClickOutside={clickOutsideHandler}
            />
        </HeaderModule>
    );
}

User.displayName = 'User';
